import React from "react";
import styled, { keyframes } from "styled-components";
import { ReactComponent as Wrong } from "../assets/svg/wrong.svg";
import { ReactComponent as Check } from "../assets/svg/check.svg";
import { ReactComponent as Star } from "../assets/svg/star.svg";

const StampMessage = ({ stars, wrong, success, text, className }) => (
  <Container className={className}>
    <Stamp>
      {wrong && <WrongStyled as={Wrong} />}
      {success && <SuccessStyled as={Check} />}
      {stars && (
        <Stars>
          <StarStyled as={Star} delay={0} />
          <StarStyled as={Star} delay={0.2} />
          <StarStyled as={Star} delay={0.4} />
        </Stars>
      )}
    </Stamp>
    <Message>{text}</Message>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const zoom = keyframes`
    from {
      transform: scale(0.3);
    }
    to {
      transform: scale(1);
    }
`;

const star = keyframes`
    from {
      opacity: 0.7;
      transform: rotate(-90deg) scale(0.3);
    }
    to {
      opacity: 1;
      transform: rotate(0deg) scale(1);
    }
`;

const Stamp = styled.div`
  margin-bottom: 15px;
`;

const Stars = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
`;

const StarStyled = styled.div`
  width: 35px;
  height: 35px;
  min-width: 35px;
  min-height: 35px;
  margin: 5px;
  opacity: 0;
  animation: ${star} 0.6s forwards ${(props) => `${props.delay || 0}s`};
`;

const WrongStyled = styled.div`
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  animation: ${zoom} 0.3s forwards;
`;

const SuccessStyled = styled.div`
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  animation: ${zoom} 0.3s forwards;
`;

const Message = styled.div`
  font-size: 1em;
  font-weight: 600;
  animation: ${zoom} 0.3s forwards;
  text-align: center;
  white-space: pre-wrap;
`;

export default StampMessage;
